var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"billcycle-container"},[_c('accountPeriod',{attrs:{"columns":_vm.columns,"searchColumns":_vm.searchColumns},on:{"handleTask":_vm.toggleTask,"handleExport":_vm.toggleExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }